export default function(values) {
  return Math.ceil(Math.log(values.length) / Math.LN2) + 1;
}



//////////////////
// WEBPACK FOOTER
// /srv/scratch/old-home/dyall/trinity/trinity-frontend-master/~/d3-array/src/threshold/sturges.js
// module id = ../../../../d3-array/src/threshold/sturges.js
// module chunks = 3